import jQuery from "jquery";
import "popper.js";
import "bootstrap";
import "bootstrap/scss/bootstrap.scss";

window.jQuery = jQuery;
window.$ = jQuery;